import {OBJECT_CREATED} from '../triggerConstants';
import {DeriveCapabilitiesArgs, DerivedCapabilities} from './types';

export default function deriveCapabilities({
  selectedSchemaSource,
  selectedTrigger,
  triggerKind,
}: DeriveCapabilitiesArgs): DerivedCapabilities {
  const canConfigureFieldChanges = selectedTrigger != null && selectedTrigger.fields.length > 0;
  const eventGroupDisabled = selectedTrigger == null;
  const scopeGroupDisabled = selectedTrigger == null || triggerKind == null;

  const objectCreatedDisabled = selectedTrigger == null || !selectedTrigger.supportsCreation;
  const fieldChangesDisabled = selectedTrigger == null || !canConfigureFieldChanges;
  const schemaScopeDisabled = scopeGroupDisabled || selectedSchemaSource == null;
  const instanceScopeDisabled = scopeGroupDisabled || triggerKind === OBJECT_CREATED;

  const showObjectCreatedUnavailableTooltip = selectedTrigger != null && !selectedTrigger.supportsCreation;
  const showFieldChangesUnavailableTooltip = selectedTrigger != null && !canConfigureFieldChanges;
  const showSchemaScopeUnavailableTooltip =
    selectedTrigger != null && triggerKind != null && selectedSchemaSource == null;
  const showObjectCreatedInstanceTooltip = selectedTrigger != null && triggerKind === OBJECT_CREATED;

  return {
    canConfigureFieldChanges,
    eventGroupDisabled,
    scopeGroupDisabled,
    objectCreatedDisabled,
    fieldChangesDisabled,
    schemaScopeDisabled,
    instanceScopeDisabled,
    showObjectCreatedUnavailableTooltip,
    showFieldChangesUnavailableTooltip,
    showSchemaScopeUnavailableTooltip,
    showObjectCreatedInstanceTooltip,
  };
}
